/**
 * The tabs of a field's page (`/tables/:tableId/fields/:fieldId/meta/:metaTab`),
 * in order. Formula only shows for a formula field; any other value opens
 * Overview.
 */
export type FieldMetaPageTab = 'overview' | 'formula' | 'permissions'

export const FIELD_META_TABS: { id: FieldMetaPageTab; label: string }[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'formula', label: 'Formula' },
  { id: 'permissions', label: 'Permissions' },
]
